import { HoleWinnerEnum, MatchSideEnum } from '../__generated__/hooks'
import { LEG_LABELS } from '../util/match-progression'

/**
 * Who took a hole, for a match's hole-by-hole table.
 *
 * One leg is the usual one name or `Delt`. Best Worst's two legs each get a
 * line — the best ball and the worst ball are separate points, and folding
 * them into one winner hides exactly the half of the hole the weaker partner
 * played for.
 */
const MatchHoleWinner = ({
  legs,
  nameFor,
}: {
  legs: readonly HoleWinnerEnum[]
  nameFor: (side: MatchSideEnum) => string | null | undefined
}) => {
  const label = (winner: HoleWinnerEnum) =>
    winner === HoleWinnerEnum.A
      ? nameFor(MatchSideEnum.A)
      : winner === HoleWinnerEnum.B
      ? nameFor(MatchSideEnum.B)
      : null

  if (legs.length <= 1) {
    const name = legs[0] ? label(legs[0]) : null
    return name ? (
      <span className="font-semibold">{name}</span>
    ) : (
      <span className="text-ink-500">Delt</span>
    )
  }

  return (
    <span className="flex flex-col items-center leading-tight">
      {legs.map((winner, i) => {
        const name = label(winner)
        return (
          // Leg position is the identity: best first, then worst.
          // eslint-disable-next-line react/no-array-index-key
          <span key={i} className="text-xs">
            <span className="text-ink-500">{LEG_LABELS[i]} </span>
            {name ? (
              <span className="font-semibold">{name}</span>
            ) : (
              <span className="text-ink-500">delt</span>
            )}
          </span>
        )
      })}
    </span>
  )
}

export default MatchHoleWinner
